import mutate from './mutators';

let actionsCache = null;

export const hasActionsCache = () => !!actionsCache;
export const hasInjectData = (rootReducer, data) => Object.keys(rootReducer).some((name) => data.hasOwnProperty(name));

export const inject = (
    fetchingDataAction,
    SET_FIELD_DATA_AS_IS,
    data,
    params = {},
    resetSelectors = [],
    rootReducer,
    globalVars = window.globalVars
) => {
    const resetData = resetSelectors.reduce((resetState, reducerSelector) => {
        resetState[reducerSelector] = rootReducer[reducerSelector](undefined, {});
        return resetState;
    }, {});

    actionsCache = [
        fetchingDataAction(false),
        {
            type: SET_FIELD_DATA_AS_IS,
            source: 'injectPageData',
            payload: mutate({ ...resetData, ...data }, params),
        },
    ];

    if (data?.request) {
        globalVars.requestId = data.request.id;
    }

    if (data?.sentryExtraData) {
        globalVars.sentryExtraData = data.sentryExtraData;
    }

    if (data?.analyticsParams) {
        globalVars.analyticsParams = data.analyticsParams;
    }
};

export const extract = function (originalAction) {
    if (!actionsCache) {
        return originalAction;
    }

    const actions = actionsCache;
    actionsCache = null;

    if (originalAction) {
        actions.push(originalAction);
    }

    return actions;
};
